'use client';

import { MEMBER_ROLES, MEMBER_TYPES } from '@slims/shared/constants';
import { validateEmail } from '@slims/shared/validation';
import { Stack } from '@slims/ui/atoms';
import { Field, Grid2, Section, SelectInput, TextInput, Toggle } from '@/components/admin/detail-fields';

interface AnagraficaTabProps {
	v: (k: string) => string;
	set: (k: string, val: string | boolean) => void;
	b: (k: string) => boolean;
}

const TYPE_OPTIONS = MEMBER_TYPES.map((t) => ({ value: t.value, label: `${t.icon} ${t.label}` }));
const ROLE_OPTIONS = MEMBER_ROLES.map((r) => ({ value: r.value, label: r.label }));

/**
 * Tab 1 — Anagrafica: solo quello che serve al profilo energetico. Il tipo dice
 * come consuma il socio (e se il profilo GSE è domestico), il ruolo quali punti
 * di misura ha, le due date da quando a quando conta nella configurazione.
 * L'email è quella dell'accesso al portale, non un contatto.
 */
export function AnagraficaTab({ v, set, b }: AnagraficaTabProps) {
	const ruolo = v('ruolo');
	return (
		<Stack gap="lg">
			<Section title="Socio">
				<Field label="Nome">
					<TextInput value={v('nome')} onChange={(x) => set('nome', x)} />
				</Field>
				<Grid2>
					<Field label="Tipo">
						<SelectInput value={v('tipo')} onChange={(x) => set('tipo', x)} options={TYPE_OPTIONS} />
					</Field>
					<Field label="Ruolo *">
						<SelectInput
							value={ruolo}
							onChange={(x) => {
								set('ruolo', x);
								// L'accumulo sta accanto a un impianto: un consumatore puro non ne ha.
								if (x === 'consumer') set('hasStorage', false);
							}}
							options={ROLE_OPTIONS}
						/>
					</Field>
				</Grid2>
				<Field label="Email di accesso al portale" error={validateEmail(v('email'))}>
					{/* Minuscola già mentre si scrive, anche col blocco maiuscole (N-11). */}
					<TextInput
						type="email"
						value={v('email')}
						onChange={(x) => set('email', x.toLowerCase())}
					/>
				</Field>
			</Section>

			<Section
				title="Nella configurazione"
				hint="Dal mese di uscita il socio non conta più nell'energia condivisa."
			>
				<Grid2>
					<Field label="Data di iscrizione">
						<TextInput type="date" value={v('dataIscrizione')} onChange={(x) => set('dataIscrizione', x)} />
					</Field>
					<Field label="Uscito dalla CER il">
						<TextInput type="date" value={v('dataRecesso')} onChange={(x) => set('dataRecesso', x)} />
					</Field>
				</Grid2>
				{(ruolo === 'producer' || ruolo === 'prosumer') && (
					<Toggle
						label="Sistema di accumulo"
						hint="Il socio dispone di una batteria - abilita il misuratore M3"
						checked={b('hasStorage')}
						onChange={() => set('hasStorage', !b('hasStorage'))}
					/>
				)}
			</Section>
		</Stack>
	);
}
